import { getDomain } from 'utilities/environment';
import SqFetch from 'application/fetch';
import getUuidByString from 'uuid-by-string';

export default class AddressClient {
  constructor(orderNumber, countryCode) {
    this.baseURL = `https://${getDomain('api.')}`;
    this.countryCode = countryCode;
    this.sessionUUID = getUuidByString(orderNumber);
  }

  _handleResponse(response) {
    if (!response.ok) {
      throw new Error(response);
    }
    return response.json();
  }

  autocompleteCandidates(partialAddress) {
    return SqFetch.post(
      `${this.baseURL}/1.0/address/get_autocomplete_candidates`,
      {
        partial_address: partialAddress,
        country_code: this.countryCode,
        session_token: this.sessionUUID,
      },
    ).then(this._handleResponse);
  }

  placeDetails(placeID) {
    return SqFetch.post(`${this.baseURL}/1.0/address/get_place_details`, {
      place_id: placeID,
      session_token: this.sessionUUID,
    }).then(this._handleResponse);
  }

  // TODO: move this into checkout.js client, so all solidshop API calls are in one client
  jpPostalCodeLookup(postalCode) {
    return SqFetch.get(
      `/shop/api/v1/checkout/postal_codes/show/jp/${postalCode.replaceAll(
        /\W/g,
        '',
      )}`,
    ).then(this._handleResponse);
  }
}
